import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaSun, FaMoon } from 'react-icons/fa';


export default function Dashboard() {
  const [dark, setDark] = useState(true);
  const [loading, setLoading] = useState(true);
  const [activePlan, setActivePlan] = useState(null);
  const [error, setError] = useState('');
const navigate = useNavigate();
const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token || token.trim() === '') {
    navigate('/login');
    return;
  }

    const fetchPlan = async () => {
      setLoading(true);
      try {
        const res = await fetch('https://api.mogym.ir/api/plan/active', {
          headers: {
          Authorization: `Bearer ${token}`,
          },
        });

        if(res.status===401)
              navigate('/login');
            
        if (!res.ok) 
          throw new Error(res.Message);

        const data = await res.json();
                localStorage.setItem('planId', data.Result.PlanId);
        setActivePlan(data.Result);
      } catch (err) {
        setError('عدم توانایی در دریافت اطلاعات برنامه فعال.');
      }
      setLoading(false);
    };

    fetchPlan();
  }, []);

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-10 font-vazir">
        <div className="max-w-2xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center mb-6">داشبورد موجیم</h1>
        {/* Header */}
          <div className="bg-blue-100 dark:bg-[#1f2b3a] p-5 rounded-xl shadow text-center">
            <h2 className="text-xl font-bold mb-1">👋 خوش آمدید!</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              از اینکه موجیم رو برای برنامه تمرینی و تغذیه‌ای خود انتخاب کردید، خوشحالیم.
            </p>
          </div>
          {loading && <p className="text-center">در حال بارگذاری...</p>}

          {error && (
            <div className="bg-red-100 dark:bg-red-800 text-red-700 dark:text-white p-4 rounded-xl text-center">
              {error}
            </div>
          )}

          {!loading && !error && activePlan && activePlan.HasActivePlan && (
            <div className="bg-blue-50 dark:bg-[#1c1f2b] text-center p-6 rounded-xl shadow">
              <h2 className="text-lg font-bold mb-2">{activePlan.Title}</h2>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                نوع پلن: {activePlan.PlanType} 
              </p>
              <Link
                to="/active-plan"
                className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-xl"
              >
                مشاهده برنامه
              </Link>
            </div>
          )}

          {!loading && !error && activePlan && !activePlan.HasActivePlan && (
            <div className="bg-yellow-100 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-200 p-4 rounded-xl text-center">
              شما در حال حاضر برنامه فعالی ندارید.
              <div className="mt-4">
                <Link
                  to="/plans"
                  className="bg-yellow-600 hover:bg-yellow-700 text-white px-5 py-2 rounded-xl"
                >
                  دریافت برنامه جدید
                </Link>
              </div>
            </div>
          )}
        </div>
                {/* دکمه‌های کلیدی داشبورد */}
<div className="mt-8 grid grid-cols-2 gap-4">
  <button
    onClick={() => navigate('/plans')}
    className="bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-xl py-6 flex flex-col items-center justify-center shadow hover:scale-105 transition"
  >
    <span className="text-2xl mb-2">📝</span>
    <span className="text-sm font-semibold">درخواست برنامه</span>
  </button>

  <button
    onClick={() => navigate('/History')}
    className="bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300 rounded-xl py-6 flex flex-col items-center justify-center shadow hover:scale-105 transition"
  >
    <span className="text-2xl mb-2">📜</span>
    <span className="text-sm font-semibold">تاریخچه</span>
  </button>

  <button
    onClick={() => navigate('/profile')}
    className="bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 rounded-xl py-6 flex flex-col items-center justify-center shadow hover:scale-105 transition"
  >
    <span className="text-2xl mb-2">👤</span>
    <span className="text-sm font-semibold">پروفایل من</span>
  </button>
</div>

        {/* کلید تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
